import BookmarkLoader from './bookmark_loader'
import BookmarkCounter from './bookmark_counter'
import BookmarkAdd from './bookmark_add'
import BookmarkItem from './bookmark_item'
import BookmarkListEmpty from './bookmark_list_empty'
import BookmarkRemove from './bookmark_remove'

export default ($context = document) => {
  $(() => {
    $('.js-bookmark-add', $context).map(function () {
      new BookmarkAdd($(this))
    })

    $('.js-bookmark-list-empty', $context).map(function () {
      new BookmarkListEmpty($(this))
    })

    $('.js-bookmarks-total', $context).map(function () {
      new BookmarkCounter($(this))
    })

    $('.js-bookmark-remove', $context).map(function () {
      new BookmarkRemove($(this))
    })

    $('.js-bookmark-item', $context).map(function () {
      new BookmarkItem($(this))
    })

    $('.js-bookmarks-loader', $context).map(function () {
      new BookmarkLoader($(this))
    })
  })
}
